import React from 'react';
import SiteFAQPage from '../components/siteContent/SiteFAQPage';

const FAQPage = () => <SiteFAQPage />;

export default FAQPage;
